/**
 * Résout la route in-app à ouvrir au tap d'une notification push, à partir de son payload (`data`).
 *
 * Le backend envoie dans le payload un champ `type` + des IDs d'entité
 * (event_id, process_id, community_id, conversation_id, remark_id...).
 *
 * Routage conservateur pour l'instant : on ouvre la page Notifications (où se font les
 * accept/refus et la lecture). Le routage précis vers les écrans cibles du brief
 * (Évènement > Planifié, Process > Participants, Découvrir > détail process, Mes groupes,
 * conversation) est à compléter une fois les routes front + la spec des cibles validées avec Marina.
 *
 * Fallback (brief) : si l'entité n'existe plus / type inconnu → page Notifications.
 */
export interface PushNotificationData {
  type?: string;
  [key: string]: unknown;
}

const NOTIFICATIONS_ROUTE = '/notifications';

export function resolveNotificationRoute(data?: PushNotificationData | null): string {
  if (!data || typeof data.type !== 'string') {
    return NOTIFICATIONS_ROUTE;
  }

  switch (data.type) {
    // Invitations, planification, remplacement, demandes/refus de groupe, remarque, test :
    // l'action (accepter/refuser) et la lecture se font sur la page Notifications.
    case 'event_invitation':
    case 'volunteering_invitation':
    case 'event_planning':
    case 'replacement_request':
    case 'community_join_request':
    case 'community_join_refused':
    case 'remark_assigned':
    case 'test':
      return NOTIFICATIONS_ROUTE;

    // TODO (routes vérifiées + spec Marina) : router vers les détails ci-dessous.
    // case 'process_status':
    // case 'process_participant_added':  -> /process/... ou /decouvrir/...
    // case 'community_join_accepted':    -> /community/... (Mes groupes)
    // case 'conversation_message':       -> /Message/...

    default:
      return NOTIFICATIONS_ROUTE;
  }
}
